// CHI DECIDE SE IL BOOST È ACCESO
//
// Sta qui, fuori da MainScene, perché è una regola con una storia: è già stata
// sbagliata una volta, e in un modo che dal codice non si vedeva. Isolata così
// si può provare senza avviare Phaser, un socket e una partita — che è
// esattamente quello che era mancato la volta scorsa.
//
// LA REGOLA
//
//   da tastiera  → barra spaziatrice
//   da mouse     → tasto premuto, purché il click non sia partito sulla UI
//   da telefono  → SOLO il pulsante BOOST del pannello dei comandi
//
// PERCHÉ SU TOUCH IL PUNTATORE NON CONTA
//
// Phaser, con `inputWindowEvents` (acceso di serie), ascolta `touchstart` anche
// su **window**, non solo sul canvas. Il joystick è un pannello DOM sopra il
// canvas: un pollice appoggiato lì non è un tocco sull'arena, ma porta comunque
// `activePointer.isDown` a `true`. Il flag "il tocco è partito sulla UI" invece
// lo muove solo l'evento di scena, e basta il `pointerup` di un altro dito per
// azzerarlo — da lì in poi `isDown && !partitoDaUI` resta vero per tutto il
// tempo in cui il pollice sterza.
//
// Il risultato era **boost acceso fisso** mentre si gioca, e di rimbalzo **cash
// out impossibile**: sul server il boost annulla l'incasso
// (`GameEngine.handleInput`), e il client manda `input_update` a ogni frame,
// quindi l'incasso veniva annullato entro un frame dall'inizio.
//
// Ci si mette anche il fatto che Phaser segue **un solo dito**
// (`input.activePointers` vale 1) mentre questo gioco si tiene con due pollici:
// dedurre il boost da uno stato globale del puntatore non poteva funzionare.

export function boostAttivo({
  spazio = false,
  puntatoreGiu = false,
  partitoDaUI = false,
  touch = false,
  joystick = false,
} = {}) {
  // Su touch il puntatore non partecipa alla decisione: decide il pulsante.
  const click = !touch && puntatoreGiu && !partitoDaUI;
  return Boolean(spazio || click || joystick);
}

export default boostAttivo;
